module.exports = __webpack_public_path__ + "static/media/times_new_roman.01d51f02.ttf";